import { useSelector } from "react-redux";
import { ConfiguratorConstants } from "../../Models/Configurator/ConfiguratorConstants";


export const getPropertyTranslation = () => {
    const { configuratorValues } = useSelector((state) => state.productConfigurator.payload);
    const wallTypeProperty = configuratorValues.find(x => x.name === ConfiguratorConstants.WallTypeProperty);

    if (!wallTypeProperty) {
        return "";
    }

    const item = window.localStorage.getItem(wallTypeProperty.name);
    if (item) {
        const mappingValues = JSON.parse(item);
        var filteredItem = mappingValues.find(x => x.optionValue === wallTypeProperty.value);
        if (filteredItem) {
            return filteredItem.optionName;
        }
    }
    return "";
}